<template>
  <div class="relative w-full max-w-screen-sm mx-auto my-2 text-xs xl:max-w-screen-lg xl:text-sm xl:my-4">
    <swiper
      :slides-per-view="6"
      :slides-per-group="3"
      :space-between="16"
      :loop="false"
      :free-mode="true"
      :navigation="{
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }"
      class="w-full px-16"
      @swiper="onSwiper"
    >
      <swiper-slide
        v-for="item in items"
        :key="item.name"
        class="relative flex justify-center"
        :class="{ 'opacity-50': !isSelected(item.name) }"
      >
        <div class="relative inline-flex flex-col items-center cursor-pointer" @click="$emit('select', item)">
          <div class="relative">
            <img :src="`plans/units/0/${item.name}.png`" class="object-contain w-32 h-20">
            <div v-if="isSelected(item.name)" class="absolute inset-0 flex items-center justify-center pointer-events-none">
              <div class="flex items-center justify-center w-6 h-6 rounded-full bg-primary-500">
                <check-icon class="text-white" />
              </div>
            </div>
          </div>
          <span>{{ item.name }}</span>
        </div>
      </swiper-slide>
    </swiper>
    <div class="-ml-16 swiper-button-prev" />
    <div class="-mr-16 swiper-button-next" />
  </div>
</template>

<script>
import SwiperCore, { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { CheckIcon } from '@zhuowenli/vue-feather-icons'

SwiperCore.use([Navigation])

export default {
  name: 'UnitList',
  components: {
    Swiper,
    SwiperSlide,
    CheckIcon,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: false,
      default () {
        return []
      },
    },
    slideTo: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  emits: ['select'],
  data () {
    return {
      swiper: undefined,
    }
  },
  activated () {
    this.$nextTick(() => {
      this.swiper.update()
      this.swiper.slideTo(this.slideTo)
    })
  },
  mounted () {
    this.$nextTick(() => {
      this.swiper.slideTo(this.slideTo)
    })
  },
  methods: {
    onSwiper (swiper) {
      this.swiper = swiper
    },
    isSelected (name) {
      return this.selected.find(item => item.name === name)
    },
  },
}
</script>

<style lang="postcss" scoped>
.swiper-wrapper {
  @apply px-16;
}
.swiper-button-next,
.swiper-button-prev {
  --swiper-navigation-size: 24px;
  margin-top: -1.5em;
}
</style>
